import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const QuizStyleContext = createContext("default");
const QuizHeaderSuffixContext = createContext(null);
function QuizStyleProvider({ variant, children, headerSuffix }) {
  return /* @__PURE__ */ jsx(QuizStyleContext.Provider, { value: variant, children: /* @__PURE__ */ jsx(QuizHeaderSuffixContext.Provider, { value: headerSuffix ?? null, children }) });
}
function useQuizStyleVariant() {
  return useContext(QuizStyleContext);
}
function useQuizHeaderSuffix() {
  return useContext(QuizHeaderSuffixContext);
}
export {
  QuizStyleProvider,
  useQuizHeaderSuffix,
  useQuizStyleVariant
};
//# sourceMappingURL=quiz-style-context.js.map
